
var editorBlocker = window.top.location.pathname.indexOf('/admin/themes/');
if( editorBlocker == -1 ){
	function redirectModal(){
		$('#redirects__cta').addClass('cta--animate');
		setTimeout(function(){ $('#redirects__cta').addClass('cta--show')}, 1500);
	}

	function checkRedirectCookie(type){
		
			ipService();
		
	}

	function setRedirectCookie(cookieName, type) {
		if( Cookies.get('multistore') ){
			Cookies.remove('multistore');
		}
		setTimeout(function(){ Cookies.set('multistore', cookieName, { expires: 365, path: '/' }); checkRedirectCookie(type); }, 150);
	}

	if(window.location.search != ''){
		var redirectValue = window.location.search.replace('?redirect=','');
		setRedirectCookie(redirectValue);
	} else {
		checkRedirectCookie();
	}

	
	$('.redirect-picker').on('change', function(){
		var url           = $(this).val(),
		selectedStore = $(".redirect-picker option:selected").html();
		setRedirectCookie(selectedStore, 'referrer');
		setTimeout(function(){ window.location.href = url+'?redirect='+selectedStore }, 300);
	});
	

	function ipService(){
		var timing = 500;

		
		var timer = setTimeout(timedOut, timing);

		console.log('Maxmind IP Service: Selected');

		function onSuccess(data){
			clearTimeout(timer);
			var location = data.country.iso_code;
			console.log('MaxMind IP Service: '+location); 
			if( location != 'US' ){
				redirectModal();
			}
		}

		function onError(error){ 
			redirectModal();
			console.log('Maxmind IP Service: '+error);
		};

		function timedOut() {
			if( !Cookies.get('IP-Service-Failed') && Cookies.get('multistore') != 'US'){
				redirectModal();
				setTimeout(function(){ Cookies.set('IP-Service-Failed', 'true', { path: '/'}); }, 150);
				console.log('Maxmind IP Service: Took to long to respond. Switching to Manual Redirect');
			}
		}

		if(Cookies.get('multistore') != 'US'){
			geoip2.country( onSuccess, onError );
		} else {
			console.log('Maxmind IP Service: Lookup bypassed user session active');
		}
		
	}
};
